import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import PaymentInfoV2 from "@/pages/checkout/components/PaymentInfo/PaymentInfoV2";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import stl from "./PaymentSuccess.module.css";
import useHelpers from "@hooks/useHelpers";
import NeedHelp from "@/_MiniApps/NeedHelp/NeedHelp";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import useBoolean from "@hooks/useBoolean";
var PaymentSuccess = function PaymentSuccess(_ref) {
  var checkoutOrderV2 = _ref.checkoutOrderV2;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var isWebView = useIsWebView();
  var webview = useWebview();
  var _useState = useState(false),
    showCarInfo = _useState[0],
    setShowCarInfo = _useState[1];
  var grantedPopup = useBoolean();
  var toggleCarInfo = function toggleCarInfo() {
    return setShowCarInfo(!showCarInfo);
  };
  var handleHomeNavigation = function handleHomeNavigation() {
    webview.openScreen("home", {})["catch"](function () {
      if (isWebView) {
        return webview.closeScreen()["catch"](function () {
          return document.location.href = "app://close";
        });
      }
      navigateToHard("/");
    });
  };
  var handleTrackingNavigation = function handleTrackingNavigation() {
    webview.openScreen("tracking_order", {})["catch"](function () {
      navigateToHard("/tracking-checkout-details/".concat(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id));
    });
  };
  var getSuccessMessage = function getSuccessMessage() {
    return /*#__PURE__*/React.createElement("span", null, t("sales_agent_contact_within_24", {
      ns: "web_checkout_cash"
    }));
  };
  var getToggleDetailsText = function getToggleDetailsText() {
    if (showCarInfo) {
      return t("hide_details", {
        ns: "web_checkout_cash"
      });
    }
    return t("view_details", {
      ns: "web_checkout_cash"
    });
  };
  var renderCarDetails = function renderCarDetails() {
    if (!checkoutOrderV2) {
      return /*#__PURE__*/React.createElement("div", {
        className: stl.loadingContainer
      }, /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 80,
        className: "mb-2"
      }), /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 30,
        className: "mb-2"
      }), /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 30,
        className: "mb-2"
      }), /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 40,
        className: "mb-2"
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: stl.carInfo
    }, renderCarContent(), /*#__PURE__*/React.createElement("div", {
      className: stl.showMoreDet,
      onClick: toggleCarInfo
    }, getToggleDetailsText()));
  };
  var renderCarContent = function renderCarContent() {
    var _checkoutOrderV2$post, _checkoutOrderV2$post2, _checkoutOrderV2$post3, _checkoutOrderV2$deta;
    if (showCarInfo) {
      return /*#__PURE__*/React.createElement("div", {
        className: stl.infoChanges
      }, /*#__PURE__*/React.createElement(PaymentInfoV2, {
        loading: false,
        checkoutOrderV2: checkoutOrderV2,
        onClickInfoIcon: grantedPopup.setTrue
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: stl.topSection
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      src: (_checkoutOrderV2$post = checkoutOrderV2.post) === null || _checkoutOrderV2$post === void 0 ? void 0 : _checkoutOrderV2$post.post_image,
      alt: (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.post_title
    })), /*#__PURE__*/React.createElement("strong", null, (_checkoutOrderV2$post3 = checkoutOrderV2.post) === null || _checkoutOrderV2$post3 === void 0 ? void 0 : _checkoutOrderV2$post3.post_title)), /*#__PURE__*/React.createElement("div", {
      className: stl.sec
    }, /*#__PURE__*/React.createElement("strong", {
      className: stl.label
    }, t("order", {
      ns: "web_checkout_cash"
    })), /*#__PURE__*/React.createElement("strong", {
      id: "payment-success_order-id",
      className: stl.orderId
    }, checkoutOrderV2.id)), /*#__PURE__*/React.createElement("div", {
      className: stl.sec
    }, /*#__PURE__*/React.createElement("strong", {
      className: stl.label
    }, t("remaining_amount", {
      ns: "web_checkout_cash"
    })), /*#__PURE__*/React.createElement("strong", {
      className: stl.price
    }, (_checkoutOrderV2$deta = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta === void 0 ? void 0 : _checkoutOrderV2$deta.total_amount, /*#__PURE__*/React.createElement("span", null, t("sar", {
      ns: "web_checkout_cash"
    })))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.alert
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(CDN_LINK, "/assets/images/check-filled.svg"),
    alt: ""
  }), /*#__PURE__*/React.createElement("strong", null, t("down_payment_paid_successfully", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.borderBottom
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(CDN_LINK, "/assets/images/check-payment.svg"),
    alt: "Success"
  }), /*#__PURE__*/React.createElement("strong", null, t("thank", {
    ns: "web_checkout_cash"
  })), getSuccessMessage(), renderCarDetails(), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.btnsWrapper, " flex-wrap")
  }, /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, stl.blueBorder, '!border-none', 'cursor-pointer', 'min-w-full', 'whtBtn'].join(" "),
    onClick: handleHomeNavigation
  }, t("back_homepge", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, stl.blueBtn, '!border-none', 'cursor-pointer', 'min-w-full'].join(" "),
    onClick: handleTrackingNavigation
  }, t("track_car_order", {
    ns: "web_checkout_cash"
  }))))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement(NeedHelp, {
    page: "PaymentSuccess",
    post_id: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.post_id
  }));
};
export default PaymentSuccess;